// SPDX-FileCopyrightText: 2026 Nextcloud cookbook contributors
//
// SPDX-License-Identifier: AGPL-3.0-only OR AGPL-3.0-or-later

export const SHOW_SETTINGS_EVENT = 'show-settings';

// export default function useSettingsDialog() {
//     return  {
//         'SHOW_SETTINGS_EVENT': SHOW_SETTINGS_EVENT
//     };
// };
